var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataComboBox',{attrs:{"value":_vm.value,"config":_vm.config},on:{"input":function($event){return _vm.$emit('input',$event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }